<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .item-header {
    display: flex;
    gap: utils.in_rem(8px);
    align-items: center;
    @include mixins.body3();

    a {
      @include colors.color(primary_50);
    }

    .item-date {
      @include colors.color(textGrey);
    }
  }

  .transcript {
    display: flex;
    flex-direction: column;
    padding: utils.in_rem(8px);
    gap: utils.in_rem(8px);
    @include colors.background-color(interfaceWhite);
    border-radius: utils.in_rem(8px);
    height: 100%;
    overflow: auto;

    .segment-group {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(8px);
      padding: utils.in_rem(16px);

      &.group-border {
        border: 1px solid colors.get(interfaceSwGrey_10);
        border-radius: utils.in_rem(8px);
      }

      .segment {
        display: flex;
        flex-direction: column;
        gap: utils.in_rem(8px);

        .segment-title {
          display: flex;
          @include mixins.body3();
          gap: utils.in_rem(8px);

          .speaker {
            font-weight: 700;
            @include colors.color(black_50);
          }

          .time {
            @include colors.color(textGrey);
          }
        }

        .segment-text {
          @include mixins.body3();
          @include colors.color(black_50);

          .highlight {
            @include colors.background-color(aiSurfacePurple);
          }
        }
      }
    }
  }
</style>

<script>
  import {
    capitalize,
    localDateString,
  } from "../../../../../assets/js/src/general/utils";
  import { todosModalItemStore } from "../stores";
  import { highlightTriggerText } from "./utils";

  let origin = $derived($todosModalItemStore?.origin);
  let trigger = $derived($todosModalItemStore?.trigger || []);

  let item = $derived(
    (origin === "meeting"
      ? $todosModalItemStore.meeting
      : $todosModalItemStore.call) || {}
  );

  let isMeeting = $derived(origin === "meeting");
  let href = $derived(
    isMeeting
      ? `/meetings?meetingId=${item.meetingId}`
      : `/calls?callId=${item.callId}`
  );

  let triggerSectionGroups = $derived(item.triggerSectionGroups || []);
  let numGroups = $derived(triggerSectionGroups.length);
</script>

{#if numGroups}
  <div class="item-header">
    <a {href} target="_blank" rel="noopener noreferrer">
      {item.title || `View ${capitalize(origin)}`}
    </a>
    <span class="item-date">{localDateString(item.timestamp)}</span>
  </div>
  <div class="transcript">
    {#each triggerSectionGroups as group}
      <div class="segment-group" class:group-border={numGroups > 1}>
        {#each group as section}
          {@const triggers = trigger
            .filter((t) => t.startTime === section.startTime)
            .map((t) => t.text)}
          <a
            class="segment"
            href="{href}&transcriptIndex={section.index}"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="segment-title">
              <span class="speaker">{section.speakerName}</span>
              <span class="time">{section.startTime}</span>
            </div>
            <div class="segment-text">
              {#each highlightTriggerText(section.text, triggers) as part}
                <span class:highlight={part.highlight}>
                  {part.text}
                </span>
              {/each}
            </div>
          </a>
        {/each}
      </div>
    {/each}
  </div>
{:else}
  We could not display the {origin} content that created this task.
{/if}
